import { toast } from "react-toastify";
import {
  ApplyFinanceSetting,
  CreateBankDetail,
  GetBankDetail,
  GetFinance,
  GetWallet,
  UpdateBankDetail,
  UpdateFinanceSetting,
} from "../api/services/finance";
import { BankDetailProps } from "../declarations/finance";

export function useFinance() {
  const getFinance = async () => {
    const response = await GetFinance();
    return response;
  };

  const applyfinanceSetting = async (payload: any) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([key, value]) =>
            value !== "" && value !== null && value !== undefined
        )
      );

      const response = await ApplyFinanceSetting(filteredPayload);
      console.log("resp", response);
      const { message, status } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in applyfinanceSetting:", error);
    }
  };

  const updateApplyFinanceSetting = async (payload: any) => {
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([key, value]) => value !== "" && value !== null && value !== undefined
      )
    );

    try {
      const response = await UpdateFinanceSetting(filteredPayload);
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 200) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const createBankingDetails = async (payload: BankDetailProps) => {
    try {
      const response = await CreateBankDetail(payload);
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const updateBankingDetails = async (payload: BankDetailProps) => {
    try {
      const response = await UpdateBankDetail(payload);
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 200) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const getBankDetails = async () => {
    try {
      const response = await GetBankDetail();
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 200) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in insuranceProvider:", error);
    }
  };

  const getWallet = async () => {
    try {
      const response = await GetWallet();
      console.log("resp", response);
      const { message, status, errors } = response;

      if (status === 200) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }
      return response;
    } catch (error) {
      console.error("Error in getWallet:", error);
      throw error;
    }
  };

  return {
    getFinance,
    applyfinanceSetting,
    createBankingDetails,
    getBankDetails,
    updateBankingDetails,
    updateApplyFinanceSetting,
    getWallet,
  };
}
